import { Apis } from "../../lib/Apis";

export const useConstructionCalculatorHook = () => {
  const addConstructionCalculator = async (data) => {
    try {
      const response = await Apis.addConstructionCalculator(data);
      return response;
    } catch (error) {
      return error;
    }
  };

  const getConstructionCalculators = async (setCalculators, setPagination, offset, limit) => {
    try {
      const response = await Apis.getConstructionCalculators(offset, limit);
      const payload = response?.data;
      // API may return either { data: [...], pagination: {...} } or a legacy nested shape.
      const list = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.data?.data)
          ? payload.data.data
          : [];
      const page = payload?.pagination ?? payload?.data?.pagination ?? null;

      if (setCalculators) setCalculators(list);
      if (setPagination && page) {
        setPagination((prev) => ({
          ...prev,
          ...page,
          // keep current query params driving these
          offset,
          limit,
        }));
      }
      return payload;
    } catch (error) {
      throw error;
    }
  };

  const updateConstructionCalculator = async (id, data) => {
    try {
      const response = await Apis.updateConstructionCalculator(id, data);
      return response;
    } catch (error) {
      return error;
    }
  };

  const deleteConstructionCalculator = async (id) => {
    try {
      const response = await Apis.deleteConstructionCalculator(id);
      return response;
    } catch (error) {
      return error;
    }
  };

  return {
    addConstructionCalculator,
    getConstructionCalculators,
    updateConstructionCalculator,
    deleteConstructionCalculator,
  };
};
